// 语言呼叫系统Api定义
var CallApi = /** @class */ (function () {
    function CallApi() {
    }
    // static baseUrl: string = "http://127.0.0.1:8085/api";
    // 通话记录列表
    CallApi.callLogPageList = function (params) {
        return CallApi.baseUrl + "/collLogRecord/pageList?" + CallApi.buildQuery(params);
    };
    // 坐席通话统计
    CallApi.callRecordAgentTotal = function (params) {
        return CallApi.baseUrl + "/collLogRecord/agentTotal?" + CallApi.buildQuery(params);
    };
    // 坐席通话统计导出
    CallApi.callRecordAgentTotalExport = function (params) {
        return CallApi.baseUrl + "/collLogRecord/agentTotalExport?" + CallApi.buildQuery(params);
    };
    // 坐席状态监控
    CallApi.agentStatusMonitor = function (params) {
        return CallApi.baseUrl + "/collLogRecord/agentStatus?" + CallApi.buildQuery(params);
    };
    // 外呼任务列表
    CallApi.callTaskPageList = function (params) {
        return CallApi.baseUrl + "/callOutTask/pageList?" + CallApi.buildQuery(params);
    };
    // Get请求构建URL参数
    CallApi.buildQuery = function (params) {
        return Object.keys(params)
            .filter(function (key) {
            // 过滤掉值为 null 或空字符串的属性
            return params[key] !== null && params[key] !== "" && params[key] !== undefined;
        })
            .map(function (key) {
            return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
        })
            .join("&");
    };
    CallApi.baseUrl = 'https://whapi.liansdk.com/api';
    // 创建外呼任务
    CallApi.createTask = CallApi.baseUrl + "/callOutTask/add";
    // 外呼任务控制
    CallApi.callTaskControl = CallApi.baseUrl + "/callOutTask/control";
    return CallApi;
}());
export { CallApi };
